import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, concat, from, split, } from "@apollo/client";
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition } from "@apollo/client/utilities";
import { createClient } from "graphql-ws";
import Cookies from "universal-cookie";
import { getCookies } from "./utils";
const endpointForClient = {
    "localhost:3000": "http://localhost:3001",
    "localhost:3002": "http://localhost:3001",
    "localhost:5173": "http://localhost:3001",
};
const BACKEND_ENDPOINT = process.env.BACKEND_ENDPOINT;
const CLIENT_SIDE_BACKEND_ENDPOINT = process.env.NEXT_PUBLIC_BACKEND_ENDPOINT || process.env.VITE_STUDIO_SERVER_URL;
export const getServerEndpoint = () => {
    if (BACKEND_ENDPOINT)
        return BACKEND_ENDPOINT;
    if (CLIENT_SIDE_BACKEND_ENDPOINT)
        return CLIENT_SIDE_BACKEND_ENDPOINT;
    try {
        if (window.location.protocol === "https:") {
            return window.location.origin;
        }
        return (endpointForClient[window.location.host] || "http://localhost:3001");
    }
    catch (_a) {
        return "http://localhost:3001";
    }
};
const wsEndpointForClient = {
    "localhost:3000": "ws://localhost:3001",
};
export const getEndpoint = () => `${getServerEndpoint()}/api`;
export const getWsServerEndpoint = () => {
    if (BACKEND_ENDPOINT)
        return BACKEND_ENDPOINT;
    if (CLIENT_SIDE_BACKEND_ENDPOINT)
        return CLIENT_SIDE_BACKEND_ENDPOINT;
    try {
        if (window.location.protocol === "https:") {
            return `wss://${window.location.host}`;
        }
        return wsEndpointForClient[window.location.host];
    }
    catch (_a) {
        return "ws://localhost:3001";
    }
};
export const getWsEndpoint = () => `${getWsServerEndpoint()}/api/sub`;
export const getFilesEndpoint = () => `${getServerEndpoint()}/files`;
export const getEtlEndpoint = () => `${getServerEndpoint()}/etl`;
const httpLink = new HttpLink({
    uri: getEndpoint(),
});
const wsLink = typeof window !== "undefined"
    ? new GraphQLWsLink(createClient({
        url: getWsEndpoint(),
    }))
    : undefined;
export const getUuid = (app) => {
    const cookies = new Cookies();
    return cookies.get(getCookies(app).uuid);
};
export const getJwtToken = (app) => {
    const cookies = new Cookies();
    return cookies.get(getCookies(app).jwt);
};
const authMiddleware = ({ headers, app, }) => new ApolloLink((operation, forward) => {
    const token = getJwtToken(app);
    const uuid = getUuid(app);
    operation.setContext({
        headers: Object.assign({ authorization: token ? `Bearer ${token}` : "", uuid, "x-client-id": app }, headers),
    });
    return forward(operation);
});
const getSplitLink = ({ headers, app, }) => {
    return wsLink
        ? concat(authMiddleware({ headers, app }), split(({ query }) => {
            const definition = getMainDefinition(query);
            return (definition.kind === "OperationDefinition" &&
                definition.operation === "subscription");
        }, wsLink, httpLink))
        : concat(authMiddleware({ headers, app }), httpLink);
};
const removeTypenameLink = removeTypenameFromVariables();
const link = ({ headers, app, getLink, }) => from([
    removeTypenameLink,
    getLink ? getLink({ headers, app }) : getSplitLink({ headers, app }),
]);
export const clientGenerator = ({ headers, app, getLink, }) => {
    return new ApolloClient({
        link: link({ headers, app, getLink }),
        cache: new InMemoryCache({
            addTypename: false,
        }),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "no-cache",
                errorPolicy: "ignore",
            },
            query: {
                fetchPolicy: "no-cache",
                errorPolicy: "all",
            },
            mutate: {
                fetchPolicy: "no-cache",
                errorPolicy: "all",
            },
        },
    });
};
//# sourceMappingURL=graphQLClient.js.map